import React, { useContext, useEffect } from 'react'
import { authContext } from '../Login/AuthContext';
import "../config.js"
import "./config.js"
import HebergementsTable from './Hebergements/HebergementsTable.js'
//import getZones, {Areas, getAreas} from "./config.js"

const BookingHebergements = () => {
  const { auth } = useContext(authContext);

  useEffect(() => {}, [auth.data])

  return (
      <div className="layout text">
        <h1 id="areas">Hebergements</h1>
        <HebergementsTable/>
      </div>
  )
}

export default BookingHebergements;
